import gql from 'graphql-tag';
import { SIMPLE_FIELD_RESPONCES_TYPE } from './SimpleFieldResponcesType.gql';

export const SIMPLE_FIELD_RESPONCES_TYPE_CONNECTION = gql`
  ${SIMPLE_FIELD_RESPONCES_TYPE}
  fragment SimpleFieldResponcesTypeConnection on SimpleFieldResponcesTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...SimpleFieldResponcesType
      }
    }
    totalCount
    edgeCount
  }
`;
